import React from 'react'
import GlobalCSS from 'src/components/GlobalCSS'
import SEO from 'src/components/seo'
import SubPageTopLayout from 'src/components/organisms/SubPageTopLayout'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'
import Container from 'src/components/atoms/policy/Container'
import Contents from 'src/components/atoms/policy/Contents'
import Content from 'src/components/atoms/policy/Content'
import ChapterName from 'src/components/atoms/policy/ChapterName'
import HeadLine from 'src/components/atoms/policy/HeadLine'
import ListUl from 'src/components/molecules/ListUl'

const UserAgreement= () => {
  return (
    <div>
      <SEO title="ユーザー向け利用規約" />
      <Container>
        <GlobalCSS />
        <Header />
        <SubPageTopLayout
          title="ユーザー向け利用規約"
          heading="USER AGREEMENT"
        />
        <ContentsWrapper>
          <Contents>
            <HeadLine>第１章　総則</HeadLine>
            <ChapterName>第１条（目的）</ChapterName>
            <Content>
              commmuneユーザー利用規約（以下「本規約」といいます。）は、コミューン株式会社（以下「当社」といいます。）が提供する企業コミュニティサービスcommmune（以下、「本サービス」といいます。）の利用に関し、当社とユーザーの間に適用されます。ユーザーは、本サービスの利用にあたり、本規約に同意したものとみなされます。
              <br />
            </Content>

            <ChapterName>第２条（定義）</ChapterName>
            <Content>
              本規約において、次の各号に掲げる用語の意味は、当該各号に定めるとおりとします。
              <br />
              （1） ユーザー
              <br />
              本規約に同意の上、commmuneのアカウント登録を完了し、コミュニティを利用する個人をいいます。
              <br />
              （2） 運用者
              <br />
              当社と契約を行い、当社から提供されたcommmune環境をユーザーに提供する法人、団体、組合または個人をいいます。
              <br />
              （3） 運用管理者
              <br />
              本サービスの利用に関する管理者権限を有し、ユーザーの本サービスの利用に必要となる設定を行う運用者の役員、従業員その他の関係者をいいます。
              <br />
              （4） コミュニティ
              <br />
              当社が本サービスを提供するために作成・公開するウェブサイトあるいはアプリケーション・ソフトウェアをいいます。
              <br />
              （5） 本サイト
              <br />
              前号のうち、特に当社が本サービスを提供するために作成・公開するウェブサイトをいいます。
              <br />
              （6） 本ソフトウェア
              <br />
              前号のうち、特に当社が本サービスを提供するために作成・公開するアプリケーション・ソフトウェアをいい、アップデート版、修正版、代替品および複製物を含みます。
              <br />
              （7） ゲスト
              <br />
              コミュニティへのアカウント登録を完了していない状態でコミュニティを利用する個人をいいます。
              <br />
              （8） 登録情報
              <br />
              コミュニティへのアカウント登録時に登録することが求められる、当社が定める一定のユーザーに関する情報をいいます。
              <br />
            </Content>

            <ChapterName>第３条（規約の変更）</ChapterName>
            <Content>
              当社は、いつでも、ユーザーの事前の承諾を得ることなく、本規約の内容を変更することができます。
              <br />
              ２　当社が本規約の内容を変更した場合には、速やかに、その変更内容をユーザーに通知するものとし、通知において指定された期日以降は、変更後の本規約が適用されます。なお、ユーザーが通知において指定された期日以後に本サービスを利用した場合には、変更後の本規約に同意したものとみなされます。
              <br />
            </Content>
            <ChapterName>第４条（通知）</ChapterName>
            <Content>
              当社は、本サービスに関連してユーザーに通知をする場合には、コミュニティに掲示する方法または登録情報として登録された電子メールアドレスに宛てて電子メールを送信する方法など、当社が適当と判断する方法で実施します。
              <br />
              ２　前項に定める方法により行われた通知は、前者の場合には通知内容がコミュニティに掲示された時点に、後者の場合は当社が電子メールを発信した時点に、それぞれその効力を生じるものとします。
              <br />
            </Content>

            <HeadLine>第２章　サービス利用上の注意事項</HeadLine>
            <ChapterName>第５条（ユーザー登録）</ChapterName>
            <Content>
              ユーザーは本規約の定めに従って本サービスを利用しなければなりません。ユーザーは、本規約に同意をしない限り本サービスを利用できません。
              <br />
              ２　運用者が本規約とは異なる利用規約を定める場合には、ユーザーは本規約を含む全ての規約の定めに従って本サービスを利用しなければなりません。
              <br />
              ３　本規約と、運用者の定める利用規約との間で矛盾、抵触が生じた場合、本規約の定めが優先するものとします。ただし、運用者の定める利用規約において別段の定めがある場合はその限りではありません。
              <br />
              ４　ユーザーが未成年者である場合には、法定代理人の同意が必要になります。未成年者がユーザーとなった場合には、全ての規約の内容について、法定代理人の同意があったものとみなします。
              <br />
            </Content>

            <ChapterName>第６条（ユーザーの責任）</ChapterName>
            <Content>
              ユーザーは自身のアカウントを自己の責任において厳重に管理するものとし、これらを用いてなされた一切の行為についてその責任を負います。
              <br />
              ２　ユーザーは、自身以外の第三者に自身のアカウントを用いて本サービスを利用させてはいけません。またユーザーは、自身のアカウントを自身以外の第三者に承継させてはいけません。
              <br />
              ３　ユーザーは、登録情報に変更の必要が生じた場合には、自らの責任で速やかに登録情報の変更をを行います。当社は、登録情報の変更がなされなかったことによりユーザーに生じた損害について一切の責任を負いません。
              <br />
              ４　本サービスを利用するために必要となる通信費（本ソフトウェアのダウンロードおよび利用のために発生する通信費を含む）、および通信機器等は、ユーザーの負担と責任により準備するものとします。ただし、ユーザーの使用する通信機器等において、本サイトおよび本ソフトウェアが正常に動作することを保証するものではありません。
              <br />
            </Content>

            <ChapterName>第７条（禁止行為）</ChapterName>
            <Content>
              ユーザーは、本サービスに関連して次の各号に定める行為を行ってはいけません。
              <br />
              （1） 当社あるいは運用者に対して虚偽の申告をする行為 <br />
              （2）当社あるいは会員もしくは第三者の財産（知的財産権を含む。）、プライバシーもしくは信用等を侵害する行為または侵害するおそれのある行為
              <br />
              （3） 犯罪行為を目的とする行為、犯罪行為を誘発させる行為 <br />
              （4）当社あるいは運用者または第三者の著作権・商標権・知的財産権などの権利を侵害する行為
              <br />
              （5）特定の個人、企業、国・地域を誹謗中傷し、又は名誉・信用を棄損する行為
              <br />
              （6）自己の商品・店舗・会社の紹介、宣伝などの商業的行為（当社あるいは運用者が認めたものは除きます。）
              <br />
              （7） 当社あるいは運用者の営業を妨害する行為 <br />
              （8）他のユーザーあるいは運用管理者になりすます行為 <br />
              （9）政治活動、選挙活動、宗教活動に関係する行為 <br />
              （10）本サービスの運営を妨げ、あるいは当社や運用者を含む第三者に不利益を与えるような行為もしくはそのおそれがある行為
              <br />
              （11） スパム行為 <br />
              （12）その他、以下に該当する表現（類似する表現も含むものとします）が含まれる投稿やコメントを行う行為
              <ListUl style={{ marginLeft: '18px' }}>
                {[
                  '事実と著しく異なると判断されるもの',
                  '具体的な事実に基づかないと判断されるもの',
                  '必要以上に感情的と判断されるもの ・差別的表現と判断されるもの',
                  'わいせつな表現などを含むもの',
                  '倫理的観点から問題があると判断されるもの',
                  '他のユーザーが不快と感じられるもの',
                  '本サービス利用の目的と関係がないと判断されるもの（会員の競合製品に特化した情報発信、等）',
                  '本サービスの秩序が乱れる可能性があると判断されるもの',
                  'ユーザーによる自作自演の可能性があると判断されるもの',
                  '当社や運用者、他のユーザーまたは第三者との私信を公開していると判断されるもの',
                  '虚偽の内容詐称やミスリーディングのおそれがあると判断されるもの',
                  '本人の承諾なく他のユーザーまたは第三者の個人情報を特定、開示するもの'
                ]}
              </ListUl>
              （13）法令に違反し、もしくは公序良俗に反する行為またはそのおそれのある行為
              <br />
              （14）コンピュータウィルスなどの有害なプログラムを使用し、もしくは送信する行為、またはそのおそれのある行為
              <br />
              （15） 他のユーザーの登録情報を不正に使用または取得する行為 <br />
              （16）前号に定めるものの他、不正アクセス行為等当社による業務の遂行、本サービスの実施もしくは当社の電気通信設備に支障を及ぼし、またはそのおそれのある行為
              <br />
            </Content>

            <ChapterName>第８条（退会方法）</ChapterName>
            <Content>
              ユーザーは、いつでもコミュニティ上から本サービスを退会することができます。ただし、運用者が退会方法を指定する場合は、ユーザーはそれに従うものとします。
              <br />
              ２　ユーザーは自身の使用する端末上で本ソフトウェアを削除または廃棄しただけでは、退会手続きは完了しません。
              <br />
              ３　ユーザーが第１項により本サービスを退会した場合、当社はユーザー情報を消去することができます。
              <br />
            </Content>

            <ChapterName>第９条（当社による退会処分）</ChapterName>
            <Content>
              当社は、ユーザーが次の各号の一つに該当した場合には、当該ユーザーに対して何らの通知催告をすることなく、当該ユーザーに対する退会処分を行い、または当該ユーザーに対する本サービスの提供を停止することができます。
              <br />
              （1） 本規約に違反する行為を行った場合 <br />
              （2）暴力団その他の反社会的勢力であると当社が合理的に判断した場合
              <br />
              （3）過去に本サービスについて退会処分を受けたことが判明した場合
              <br />
              （4）その他、当社がユーザーとして不適当であると合理的に判断した場合
              <br />
              ２　第１項に基づきユーザーが退会処分を受けた場合、当社はユーザー情報を消去することができます。
              <br />
            </Content>

            <HeadLine>第３章　サービスの提供</HeadLine>
            <ChapterName>第１０条（データとバックアップ）</ChapterName>
            <Content>
              本サービスにおいてユーザーのコミュニティの利用に関わるデータ（以下「データ」といいます。）は、すべて当社が委託している本サービス用サーバ（以下「本サービス用サーバ」といいます。）に保存及び蓄積されます。
              <br />
              ２　当社は、本サービスに関わるデータを定期的なバックアップにより保管します。当社は、バックアップを原則として毎日１回行うものとします。
              <br />
              ３　当社は、システムの障害等によってデータ等が消失した場合、当社がバックアップしたデータ等を用いて復旧するものとします。
              <br />
              ４　当社はデータが消失するリスクをできる限り低くするよう努めますが、遠隔地を含めたデータ保管場所の全てに障害が発生した場合には、データが消失する可能性があります。ユーザーは予めこれを承諾するものとし、当社はデータの消失によりユーザーに発生した損害の賠償をする責任を負わないものとします。
              <br />
            </Content>

            <ChapterName>第１１条（サービスの停止）</ChapterName>
            <Content>
              当社は、次の各号のいずれかの事由が生じた場合には、事前にユーザーに通知をすることなく、本サービスの一部または全部を停止することができます。
              <br />
              （1）本サービス提供にあたり必要なシステム、設備等に障害が発生し、またはメンテナンス、保守もしくは工事等が必要となった場合
              <br />
              （2）電気通信事業者が電気通信サービスの提供を中止するなど、当社あるいは運用者以外の第三者の行為に起因して、本サービスの提供を行うことが困難になった場合
              <br />
              （3）非常事態（天災、戦争、テロ、暴動、騒乱、官の処分、労働争議等）の発生により、本サービスの提供が困難になった場合、または困難になる可能性のある場合
              <br />
              （4）法令規制、行政命令等により、本サービスの提供が困難になった場合
              <br />
              （5）その他、当社の責めに帰することができない事由により、当社が必要やむを得ないと判断した場合
              <br />
              ２　当社は、前項に基づいて本サービスを停止したことによりユーザーまたは第三者に損害が発生した場合でも、一切の責任を負いません。
              <br />
            </Content>

            <ChapterName>第１２条（サービスの変更、中止及び終了）</ChapterName>
            <Content>
              当社は、事前にユーザーに通知をしたうえで、本サービスの一部もしくは全部の内容を変更、中止または終了することができます。但し、変更、中止または終了の内容が重大でない場合には、通知をすることなくこれらを実施することができます。
              <br />
              ２　当社は、前項に基づいて本サービスを変更、中止または終了したことによりユーザーに損害が発生した場合でも、一切の責任を負いません。
              <br />
            </Content>

            <HeadLine>第４章　本ソフトウェアの提供</HeadLine>
            <ChapterName>第１３条（使用許諾）</ChapterName>
            <Content>
              当社は、本サービスの利用に際して本ソフトウェアをダウンロードしたユーザーに対し、本規約に従うことを条件に、非独占的な使用を許諾します。なお、本ソフトウェアの著作権は当社に帰属します。
              <br />
            </Content>

            <ChapterName>第１４条（ソフトウェアに関する禁止事項）</ChapterName>
            <Content>
              ユーザーは、本ソフトウェアの利用にあたり、第７条に定める事項の他、次の各号に定める行為を行ってはいけません。
              <br />
              （1）本ソフトウェアの複製、翻訳、翻案等の改変を行うこと
              <br />
              （2）本ソフトウェアの販売、配布、再使用許諾、公衆送信（送信可能化を含む）、貸与、譲渡、またはリースその他の処分を行うこと
              <br />
              （3）本ソフトウェアに設けられたコピーガード等の技術的な保護手段を回避する方法で使用すること
              <br />
              （4）本ソフトウェアの一部または全部のリバースエンジニアリング、逆コンパイルもしくは逆アセンブルを行い、またはその他の方法でソースコードを抽出すること
              <br />
              （5）第三者が複製できるように本ソフトウェアを公開すること
              <br />
              （6）前各号に定める他、本ソフトウェアの利用目的に照らして当社が不適切と判断する行為
              <br />
            </Content>

            <ChapterName>第１５条（利用制限）</ChapterName>
            <Content>
              次の各号に定める場合、ユーザーによる本ソフトウェアの利用の一部または全部が制限されることがあります。
              <br />
              （1）利用資格等の確認を目的としたライセンス認証、会員ID等の認証機能において、利用資格等の確認ができない場合。
              <br />
              （2）インターネット接続ができない場所において本ソフトウェアを利用する場合
              <br />
              （3）リアルタイム通信ができない通信状況において本ソフトウェアを利用する場合
              <br />
              ２　当社は、本ソフトウェアに関するサポート、修正版（アップデート版を含みます）の提供を行う義務を負いません。またあらかじめユーザーへ通知を行うことなく、本ソフトウェアの修正、変更、アップデート、または提供の終了を行う場合があります。
              <br />
            </Content>

            <HeadLine>第５章　一般条項</HeadLine>
            <ChapterName>第１６条（保証）</ChapterName>
            <Content>
              当社は、本サービスが推奨環境において機能するように合理的な最大限の努力を行います。但し、当社は、本サービスを通じて当社あるいは運用者が提供し、またはユーザーが取得した情報が正確性、正当性、有用性、完全性等を有することを保証するものではありません。
              <br />
            </Content>

            <ChapterName>第１７条（知的財産権）</ChapterName>
            <Content>
              本サービスに関する著作権、著作者人格権、特許権、意匠権、商標権及びパブリシティ権等の知的財産権は当社及び正当な権利者たる第三者に帰属します。
              <br />
              ２　投稿にかかる著作権等は、当該投稿を行ったユーザー本人に帰属しますが、投稿されたことをもって、ユーザーは当社および運用者に対し、投稿コンテンツを、全世界において無償で非独占的に使用する（加工、抜粋、複製、公開、翻訳などを含む）権利を許諾したものとし、かつ、当社および運用者に対して著作権等を行使しないことに予め承諾したものとします。
              <br />
              ３　当社および運用者は投稿などのコンテンツを運営上必要に応じて閲覧することがあります。また、投稿などのコンテンツが本規約に抵触すると判断した場合には、事前通知なしに非公開または削除することがあります。
              <br />
            </Content>

            <ChapterName>第１８条（損害賠償及び免責）</ChapterName>
            <Content>
              当社は、本サービスを利用したこと、あるいは利用しなかったことに起因する、ユーザーに生じた損害について、一切その責任を負いません。
              <br />
              ２　本サービスに関してユーザーと他のユーザーあるいは第三者（ただし、運用者を除きます。）との間に紛争が生じた場合、ユーザーは自己の責任と費用で解決するものとし、当社および運用者に何ら迷惑をかけず、またこれにより当社が被った損害（弁護士費用を含む。）を補償します。
              <br />
              ３　本サービスに関してユーザーと運用者との間に紛争が生じた場合、ユーザーは自己の責任と費用で解決するものとし、当社に何ら迷惑をかけず、またこれにより当社が被った損害（弁護士費用を含む。）を補償します。
              <br />
              ４　当社は、前項までの場合の他、本サービス内に関連する事項に起因又は関連してユーザーに生じたいかなる損害についても、一切責任を負いません。
              <br />
            </Content>

            <ChapterName>第１９条（委託）</ChapterName>
            <Content>
              当社は、本サービスに関する業務の一部または全部を第三者に委託することができるものとします（以下その場合の当該第三者を「下請業者」といいます。）。
              <br />
            </Content>

            <ChapterName>第２０条（情報管理）</ChapterName>
            <Content>
              当社は、ユーザー情報について、ユーザーの事前の同意を得ずに第三者に開示しません。但し、次の各号の場合はこの限りではありません。
              <br />
              （1）法令または公的機関からの要請を受け、要請に応じる必要を認めた場合
              <br />
              （2）人の生命、身体または財産の保護のために必要があり、かつ会員の同意を得ることが困難である場合
              <br />
              （3） サービス提供のために必要な受託者、または代理人
              <br />
              ２　前項にかかわらず、当社は、運用管理者およびユーザー情報の属性集計・分析を行い、運用管理者およびユーザーが識別・特定できないように加工したもの（以下「統計資料」といいます。）を作成し、本サービス及び当社のその他のサービスのために利用することがあります。また、統計資料を第三者に開示することがあります。
              <br />
              ３　当社は、ユーザー情報の紛失、破壊、改鼠、漏洩等の危険に対して、合理的な最大限の安全対策を講じます。
              <br />
              ４　当社は、電話応対品質向上等のため、ユーザーとの間の電話応対を録音し、及び録音内容を業務において使用することができます。
              <br />
            </Content>

            <ChapterName>第２１条（個人情報）</ChapterName>
            <Content>
              当社の個人情報の取り扱いについてはプライバシーポリシーに定めるとおりとします。
              <br />
            </Content>

            <ChapterName>第２２条（準拠法、管轄裁判所）</ChapterName>
            <Content>
              本規約は日本法によって解釈され、日本法を準拠法とします。
              <br />
              ２　ユーザーと当社の間に紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
              <br />
              <br />
              <br />
              <br />
              附則 平成30年7月20日　制定・施行 <br />
              令和3年3月11日　改定
              <br />
            </Content>
          </Contents>
        </ContentsWrapper>
        <Footer />
      </Container>
    </div>
  )
}
export default UserAgreement
